import { useSession } from '~/contexts/SessionContext';
import { Patient } from '~/domain/patient/patient';

export function usePatient(): Patient {
    return useSession().patient;
}
